<template>
  <div>
    <div class="native-keyboard">
      <input
        v-model="text"
        ref="input"
        style="opacity: 1"
        size="3"
        @input="inputChange"
      />
      {{ inputText }}
      <button @click="keyboardVisiable = !keyboardVisiable">set focus</button
      >{{ keyboardVisiable }}
    </div>
    <div class="ios-keyboard" v-show="IOSKeyboardVisiable">
      <div class="simple-keyboard"></div>
    </div>
  </div>
</template>
<script>
import SimpleKeyboard from "simple-keyboard";
import "simple-keyboard/build/css/index.css";

export default {
  name: "Keyboard",
  props: {
    isDesktop: { type: Boolean, default: false },
    isIOS: { type: Boolean, default: false },
    isAndroid: { type: Boolean, default: false },
  },
  data() {
    return {
      focus: false,
      text: "",
      inputText: "",
      keyboard: null,
      keyboardVisiable: false,
      IOSKeyboardVisiable: false,
    };
  },
  watch: {
    keyboardVisiable(val) {
      if (this.isDesktop) {
        console.log("keyvisiable:", val);
        return;
      }
      if (this.isIOS) {
        this.IOSKeyboardVisiable = val;
      } else {
        if (val) {
          this.$refs.input.focus();
        } else {
          this.$refs.input.blur();
        }
      }
    },
  },
  mounted() {
    console.log("mobile", device.mobile());
    console.log("tablet", device.tablet());
    console.log("desktop", device.desktop());
    this.keyboard = new SimpleKeyboard({
      layout: {
        default: [
          "` 1 2 3 4 5 6 7 8 9 0 - = {bksp}",
          "q w e r t y u i o p [ ] \\",
          "a s d f g h j k l ; '",
          "{shift} z x c v b n m , . / {shift}",
          "{space}",
        ],
        shift: [
          "~ ! @ # $ % ^ & * ( ) _ + {bksp}",
          "Q W E R T Y U I O P { } |",
          'A S D F G H J K L : "',
          "{shift} Z X C V B N M < > ? {shift}",
          "{space}",
        ],
      },
      onKeyPress: (button) => this.IOSonKeyPress(button),
    });
  },
  methods: {
    setKeyboardFocus(val) {
      this.keyboardVisiable = val;
    },
    inputChange(e) {
      if (this.isDesktop) {
        return;
      }
      if (e.data == null) {
        this.inputText = "backspace";
      } else if (e.data == " ") {
        this.inputText = "space";
      } else {
        this.inputText = e.data;
      }
      this.$parent.sendFurioosMsg({
        sinewave: "keyboardinput",
        value: this.inputText,
      });
    },

    IOSonKeyPress(button) {
      console.log("Button pressed", button);
      if (button === "{shift}" || button === "{lock}") {
        this.handleShift();
        return;
      }

      if (button == "{bksp}") {
        this.inputText = "backspace";
      } else if (button == "{space}") {
        this.inputText = "space";
      } else {
        this.inputText = button;
      }
      this.$parent.sendFurioosMsg({
        sinewave: "keyboardinput",
        value: this.inputText,
      });
    },
    handleShift() {
      let currentLayout = this.keyboard.options.layoutName;
      let shiftToggle = currentLayout === "default" ? "shift" : "default";

      this.keyboard.setOptions({
        layoutName: shiftToggle,
      });
    },
  },
};
</script>
<style scoped>
.native-keyboard {
  position: absolute;
  bottom: 0;
  left: -200px;
}
.ios-keyboard {
  position: absolute;
  bottom: 0;
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/Keyboard.vue